var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"toolbox",class:_vm.classes},[_c('div',{staticClass:"main-content"},[_vm._t("default")],2),_c('div',{staticClass:"description"},[_vm._v(" "+_vm._s(_vm.subject || '')+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }